<form class="card-form" [formGroup]="form" (ngSubmit)="submit()">
  <mat-card>
    <mat-card-content>
      <p i18n="text @@auth.form.2fa.explanation.recovery">Please enter one of your generated backup codes to login to your account.</p>
      <p>
        <mat-form-field appearance="fill">
          <mat-label i18n="@@shared.2fa.code">Enter a backup code</mat-label>
          <input type="text" matInput formControlName="backupCode" tcAutofocus />
          <mat-error *tcMatFormFieldError="'identity.2fa.invalid_code'" i18n="error @@auth.form.2fa.invalid.code">
            Invalid Code
          </mat-error>
          <mat-error *tcMatFormFieldError="'identity.2fa.validation_error'" i18n="error @@auth.form.2fa.again.code">
            Try Again!
          </mat-error>
        </mat-form-field>
      </p>
    </mat-card-content>
    <mat-card-actions>
      <a mat-button color="primary" (click)="goBackToLogin()" i18n="button @@auth.form.2fa.back">BACK</a>
      <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid" i18n="button @@auth.form.2fa.submit">VERIFY</button>
    </mat-card-actions>
  </mat-card>
</form>
